var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 343.605,
    y1: 574.503,
    x2: 343.605,
    y2: 289.819,
    gradientTransform: "translate(0 -130.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1647c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8c7ac"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.9 159.6h279.3c9.2 0 16.7 7.5 16.7 16.7v184.6c0 9.2-7.5 16.7-16.7 16.7h-29.6v4.7l.2 54.2c.1 7.3-9.3 10.5-13.7 4.7l-62.6-63.6H203.9c-9.2 0-16.7-7.5-16.7-16.7V176.3c0-9.2 7.4-16.7 16.6-16.7h.1z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.9 310.3c0 2.2-.8 4.2-2.3 5.8-1.6 1.6-3.2 2.5-5.2 2.5-3.5 0-17.8-10-42.9-29.9l-21.9 23.1c-5.5 5.6-9.4 8.3-11.6 8.3-2.2 0-4.3-.9-5.8-2.5-1.6-1.5-2.5-3.6-2.5-5.8 0-2.7 3.1-6.8 9.2-12.3 10.4-9.4 17.8-16.7 22.5-21.8-15.2-15.1-25.3-28.6-30.2-40.5-3.1-1.7-4.6-4-4.6-6.7 0-2.3.8-4.4 2.4-6 1.4-1.6 3.5-2.5 5.6-2.5 3-.1 5.8 1.2 7.6 3.5 1.4 1.6 3.2 4.9 5.6 9.9 4.3 9.2 12.2 19.4 23.7 30.4 8.6-9.6 15.2-18.9 19.7-28 1.6-3.7 3.2-7.4 4.9-11.1 1.6-3 3.9-4.5 6.9-4.5 2.2-.1 4.4.7 6 2.3 1.6 1.5 2.3 3.5 2.3 6 0 9.5-9.3 25.3-27.9 47.3 4.9 4.2 14.2 11.1 27.8 20.7 7.1 4.9 10.7 8.9 10.7 11.8z",
    fill: "#c45c6a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 160.034,
    y1: 523.181,
    x2: 152.795,
    y2: 62.475,
    gradientTransform: "translate(0 -130.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45af8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e8ae"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.1 52.4H16.7C7.5 52.4 0 59.9 0 69.1v184.6c0 9.2 7.5 16.7 16.7 16.7h29.6v4.7l-.2 54.2c-.1 7.3 9.3 10.5 13.7 4.7l62.6-63.5h173.7c9.2 0 16.7-7.5 16.7-16.7V69.1c0-9.2-7.4-16.7-16.6-16.7h-.1z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#449b7f",
    strokeWidth: 23,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M111.7 164.8l35.3 36.7 40.6-82.9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswers);
export default __webpack_public_path__ + "static/media/answers.f81933feb0c643a123eab374d44e79a8.svg";
export { ForwardRef as ReactComponent };